import { memo } from 'react';

import SearchCheckmarkIconSVG from '@/assets/search-checkmark-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISearchCheckmarkIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={SearchCheckmarkIconSVG} {...props} />
);

export const SearchCheckmarkIcon = memo(ISearchCheckmarkIcon) as typeof ISearchCheckmarkIcon;
